<template>
  <BcTabs
    v-model="tab"
    :list="ANALYTICS_TAB_LIST"
  />
</template>

<script setup lang="ts">
import { ANALYTICS_TAB_LIST } from '~/constants/analytics.constants'
import { analyticsPageTab } from '~/routes/analytics'
import BcTabs from '~/ui/Tabs/BcTabs.vue'
import { isSamePage } from '~/utils/route.util'

const route = useRoute()
const router = useRouter()

const extractTabFromPath = (path: string) => {
  return path.split('/').at(-1) as analyticsPageTab || analyticsPageTab.user
}
const tab = ref(extractTabFromPath(route.path))

onBeforeRouteUpdate((guard) => {
  if (isSamePage(guard.path, route.path)) {
    tab.value = extractTabFromPath(guard.path)
  }
})

watch(() => tab.value, () => {
  router.push(routes.getAnalyticsPage(tab.value))
})
</script>

<style scoped lang="scss">

</style>